import api from './api';

/**
 * Get fingerprint data for short code login
 * @returns {{platform: string, user_agent: string}}
 */
export const getFingerprint = () => {
  return {
    platform: navigator.userAgentData?.platform || 'Unknown',
    user_agent: navigator.userAgent,
  };
};

/**
 * Request short code login
 * @param {string} email - User email
 * @returns {Promise<{challenge_id: string, expire_at: number}>}
 */
export const requestShortCode = async (email) => {
  try {
    const response = await api.post('/api/auth/short-code-login/request', {
      email,
      fingerprint: getFingerprint(),
    });
    
    // Interceptor handles unified structure, return data directly
    return response.data;
  } catch (error) {
    console.error('Short code request failed:', error);
    throw error;
  }
};

/**
 * Verify short code login
 * @param {string} challengeId - Challenge ID from request response
 * @param {string} code - 6-character code from email
 * @returns {Promise<{access_token: string, refresh_token: string}>}
 */
export const verifyShortCode = async (challengeId, code) => {
  try {
    const response = await api.post('/api/auth/short-code-login/verify', {
      challenge_id: challengeId,
      code: code.toUpperCase(), // Ensure uppercase
    });
    
    // Interceptor handles unified structure, return data directly
    return response.data;
  } catch (error) {
    console.error('Short code verification failed:', error);
    throw error;
  }
};
